
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productSlug]",
      function () {
        return require("private-next-pages/product/[productSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/[productSlug]"])
      });
    }
  